/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface CustomerPaymentMethodsService {
  /** @summary Get Customer Payment Methods */
  getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet: {
    /** @summary Get Customer Payment Methods */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        options: {
          parameters: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >
    >;
    /** @summary Get Customer Payment Methods */
    getQueryKey(
      parameters: DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
    ): ServiceOperationQueryKey<
      GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
      GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError>>;
    /** @summary Get Customer Payment Methods */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
      GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useInfiniteQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
      TQueryFnData = GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<
      TData,
      OperationError<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useInfiniteQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
      TQueryFnData = GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetTotal = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetByParametersTotal = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetResults = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetCombinedResults = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useSuspenseQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<
      TData,
      OperationError<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useSuspenseInfiniteQuery({
     *     path: {
     *         customer_id: customerId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
      TData = GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError,
          OperationInfiniteData<TData, GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>,
      OperationError<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Customer Payment Methods
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetCombinedData = qraft.customerPaymentMethodsService.getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Customer Payment Methods */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >
    ): Promise<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData>;
    /** @summary Get Customer Payment Methods */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >
    ): Promise<void>;
    /** @summary Get Customer Payment Methods */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >
    ): Promise<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData>;
    /** @summary Get Customer Payment Methods */
    fetchInfiniteQuery<TPageParam extends GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
        DeepReadonly<TPageParam>,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
      >
    >;
    /** @summary Get Customer Payment Methods */
    prefetchInfiniteQuery<TPageParam extends GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
        DeepReadonly<TPageParam>,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >
    ): Promise<void>;
    /** @summary Get Customer Payment Methods */
    ensureInfiniteQueryData<TPageParam extends GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
        DeepReadonly<TPageParam>,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
      >
    >;
    /** @summary Get Customer Payment Methods */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
    ): GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData | undefined;
    /** @summary Get Customer Payment Methods */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
    ):
      | OperationInfiniteData<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
        >
      | undefined;
    /** @summary Get Customer Payment Methods */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
                    GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
            >,
            data: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData | undefined,
          ]
        >;
    /** @summary Get Customer Payment Methods */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
    ):
      | QueryState<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
        >
      | undefined;
    /** @summary Get Customer Payment Methods */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
        >
      | undefined;
    /** @summary Get Customer Payment Methods */
    setQueryData(
      parameters:
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
        | ServiceOperationQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >,
      updater: Updater<
        NoInfer<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData> | undefined,
        NoInfer<DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData | undefined;
    /** @summary Get Customer Payment Methods */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
              GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
                GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
          GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters
        >
      | undefined;
    /** @summary Get Customer Payment Methods */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >,
      updater: Updater<
        NoInfer<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData> | undefined,
        NoInfer<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData | undefined>;
    /** @summary Get Customer Payment Methods */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
        TInfinite,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
        GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Customer Payment Methods */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Customer Payment Methods */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Customer Payment Methods */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
    ): void;
    /** @summary Get Customer Payment Methods */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Customer Payment Methods */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData,
            TInfinite,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters,
            GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError
          >
    ): number;
    schema: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema;
    types: {
      parameters: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters;
      data: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData;
      error: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError;
    };
  };
  /** @summary Setup Customer Payment Method */
  setupCustomerPaymentMethod: {
    /** @summary Setup Customer Payment Method */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SetupCustomerPaymentMethodBody,
        SetupCustomerPaymentMethodParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SetupCustomerPaymentMethodSchema,
        options: ServiceOperationMutationFnOptions<
          SetupCustomerPaymentMethodBody,
          SetupCustomerPaymentMethodParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<SetupCustomerPaymentMethodData, SetupCustomerPaymentMethodError>>
    ): Promise<RequestFnResponse<SetupCustomerPaymentMethodData, SetupCustomerPaymentMethodError>>;
    /** @summary Setup Customer Payment Method */
    getMutationKey(
      parameters: DeepReadonly<SetupCustomerPaymentMethodParameters> | void
    ): ServiceOperationMutationKey<SetupCustomerPaymentMethodSchema, SetupCustomerPaymentMethodParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Setup Customer Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SetupCustomerPaymentMethodBody, TContext = unknown>(
      parameters: DeepReadonly<SetupCustomerPaymentMethodParameters>,
      options?: ServiceOperationUseMutationOptions<
        SetupCustomerPaymentMethodSchema,
        SetupCustomerPaymentMethodData,
        SetupCustomerPaymentMethodParameters,
        TVariables,
        OperationError<SetupCustomerPaymentMethodError>,
        TContext
      >
    ): UseMutationResult<
      SetupCustomerPaymentMethodData,
      OperationError<SetupCustomerPaymentMethodError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Setup Customer Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SetupCustomerPaymentMethodBody, SetupCustomerPaymentMethodParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SetupCustomerPaymentMethodSchema,
        SetupCustomerPaymentMethodData,
        SetupCustomerPaymentMethodParameters,
        TVariables,
        OperationError<SetupCustomerPaymentMethodError>,
        TContext
      >
    ): UseMutationResult<
      SetupCustomerPaymentMethodData,
      OperationError<SetupCustomerPaymentMethodError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Setup Customer Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const setupCustomerPaymentMethodTotal = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const setupCustomerPaymentMethodTotal = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SetupCustomerPaymentMethodBody,
            SetupCustomerPaymentMethodData,
            SetupCustomerPaymentMethodParameters,
            OperationError<SetupCustomerPaymentMethodError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupCustomerPaymentMethodSchema,
            SetupCustomerPaymentMethodBody,
            SetupCustomerPaymentMethodData,
            SetupCustomerPaymentMethodParameters,
            OperationError<SetupCustomerPaymentMethodError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Setup Customer Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const setupCustomerPaymentMethodPendingMutationVariables = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const setupCustomerPaymentMethodMutationData = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SetupCustomerPaymentMethodData,
        OperationError<SetupCustomerPaymentMethodError>,
        MutationVariables<SetupCustomerPaymentMethodBody, SetupCustomerPaymentMethodParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SetupCustomerPaymentMethodBody,
            SetupCustomerPaymentMethodData,
            SetupCustomerPaymentMethodParameters,
            OperationError<SetupCustomerPaymentMethodError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupCustomerPaymentMethodSchema,
            SetupCustomerPaymentMethodBody,
            SetupCustomerPaymentMethodData,
            SetupCustomerPaymentMethodParameters,
            OperationError<SetupCustomerPaymentMethodError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SetupCustomerPaymentMethodData,
          OperationError<SetupCustomerPaymentMethodError>,
          MutationVariables<SetupCustomerPaymentMethodBody, SetupCustomerPaymentMethodParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Setup Customer Payment Method */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SetupCustomerPaymentMethodBody,
            SetupCustomerPaymentMethodData,
            SetupCustomerPaymentMethodParameters,
            OperationError<SetupCustomerPaymentMethodError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupCustomerPaymentMethodSchema,
            SetupCustomerPaymentMethodBody,
            SetupCustomerPaymentMethodData,
            SetupCustomerPaymentMethodParameters,
            OperationError<SetupCustomerPaymentMethodError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Setup Customer Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.customerPaymentMethodsService.setupCustomerPaymentMethod.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SetupCustomerPaymentMethodBody,
              SetupCustomerPaymentMethodData,
              SetupCustomerPaymentMethodParameters,
              OperationError<SetupCustomerPaymentMethodError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetupCustomerPaymentMethodSchema,
              SetupCustomerPaymentMethodBody,
              SetupCustomerPaymentMethodData,
              SetupCustomerPaymentMethodParameters,
              OperationError<SetupCustomerPaymentMethodError>,
              TContext
            >
      ):
        | Mutation<
            SetupCustomerPaymentMethodData,
            SetupCustomerPaymentMethodError,
            MutationVariables<SetupCustomerPaymentMethodBody, SetupCustomerPaymentMethodParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SetupCustomerPaymentMethodBody,
              SetupCustomerPaymentMethodData,
              SetupCustomerPaymentMethodParameters,
              OperationError<SetupCustomerPaymentMethodError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetupCustomerPaymentMethodSchema,
              SetupCustomerPaymentMethodBody,
              SetupCustomerPaymentMethodData,
              SetupCustomerPaymentMethodParameters,
              OperationError<SetupCustomerPaymentMethodError>,
              TContext
            >
      ): Array<
        Mutation<
          SetupCustomerPaymentMethodData,
          SetupCustomerPaymentMethodError,
          MutationVariables<SetupCustomerPaymentMethodBody, SetupCustomerPaymentMethodParameters>,
          TContext
        >
      >;
    };
    schema: SetupCustomerPaymentMethodSchema;
    types: {
      parameters: SetupCustomerPaymentMethodParameters;
      data: SetupCustomerPaymentMethodData;
      error: SetupCustomerPaymentMethodError;
      body: SetupCustomerPaymentMethodBody;
    };
  };
  /** @summary Set Default Payment Method */
  setDefaultPaymentMethod: {
    /** @summary Set Default Payment Method */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SetDefaultPaymentMethodBody,
        SetDefaultPaymentMethodParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SetDefaultPaymentMethodSchema,
        options: ServiceOperationMutationFnOptions<
          SetDefaultPaymentMethodBody,
          SetDefaultPaymentMethodParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<SetDefaultPaymentMethodData, SetDefaultPaymentMethodError>>
    ): Promise<RequestFnResponse<SetDefaultPaymentMethodData, SetDefaultPaymentMethodError>>;
    /** @summary Set Default Payment Method */
    getMutationKey(
      parameters: DeepReadonly<SetDefaultPaymentMethodParameters> | void
    ): ServiceOperationMutationKey<SetDefaultPaymentMethodSchema, SetDefaultPaymentMethodParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Set Default Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useMutation({
     *     path: {
     *         customer_id: customerId,
     *         payment_method_id: paymentMethodId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId,
     *         payment_method_id: paymentMethodId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SetDefaultPaymentMethodBody, TContext = unknown>(
      parameters: DeepReadonly<SetDefaultPaymentMethodParameters>,
      options?: ServiceOperationUseMutationOptions<
        SetDefaultPaymentMethodSchema,
        SetDefaultPaymentMethodData,
        SetDefaultPaymentMethodParameters,
        TVariables,
        OperationError<SetDefaultPaymentMethodError>,
        TContext
      >
    ): UseMutationResult<
      SetDefaultPaymentMethodData,
      OperationError<SetDefaultPaymentMethodError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Set Default Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useMutation({
     *     path: {
     *         customer_id: customerId,
     *         payment_method_id: paymentMethodId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId,
     *         payment_method_id: paymentMethodId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SetDefaultPaymentMethodBody, SetDefaultPaymentMethodParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SetDefaultPaymentMethodSchema,
        SetDefaultPaymentMethodData,
        SetDefaultPaymentMethodParameters,
        TVariables,
        OperationError<SetDefaultPaymentMethodError>,
        TContext
      >
    ): UseMutationResult<
      SetDefaultPaymentMethodData,
      OperationError<SetDefaultPaymentMethodError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Set Default Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const setDefaultPaymentMethodTotal = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const setDefaultPaymentMethodTotal = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId,
     *             payment_method_id: paymentMethodId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SetDefaultPaymentMethodBody,
            SetDefaultPaymentMethodData,
            SetDefaultPaymentMethodParameters,
            OperationError<SetDefaultPaymentMethodError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetDefaultPaymentMethodSchema,
            SetDefaultPaymentMethodBody,
            SetDefaultPaymentMethodData,
            SetDefaultPaymentMethodParameters,
            OperationError<SetDefaultPaymentMethodError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Set Default Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const setDefaultPaymentMethodPendingMutationVariables = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const setDefaultPaymentMethodMutationData = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId,
     *                 payment_method_id: paymentMethodId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SetDefaultPaymentMethodData,
        OperationError<SetDefaultPaymentMethodError>,
        MutationVariables<SetDefaultPaymentMethodBody, SetDefaultPaymentMethodParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SetDefaultPaymentMethodBody,
            SetDefaultPaymentMethodData,
            SetDefaultPaymentMethodParameters,
            OperationError<SetDefaultPaymentMethodError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetDefaultPaymentMethodSchema,
            SetDefaultPaymentMethodBody,
            SetDefaultPaymentMethodData,
            SetDefaultPaymentMethodParameters,
            OperationError<SetDefaultPaymentMethodError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SetDefaultPaymentMethodData,
          OperationError<SetDefaultPaymentMethodError>,
          MutationVariables<SetDefaultPaymentMethodBody, SetDefaultPaymentMethodParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Set Default Payment Method */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SetDefaultPaymentMethodBody,
            SetDefaultPaymentMethodData,
            SetDefaultPaymentMethodParameters,
            OperationError<SetDefaultPaymentMethodError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetDefaultPaymentMethodSchema,
            SetDefaultPaymentMethodBody,
            SetDefaultPaymentMethodData,
            SetDefaultPaymentMethodParameters,
            OperationError<SetDefaultPaymentMethodError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Set Default Payment Method
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId,
     *             payment_method_id: paymentMethodId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.customerPaymentMethodsService.setDefaultPaymentMethod.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SetDefaultPaymentMethodBody,
              SetDefaultPaymentMethodData,
              SetDefaultPaymentMethodParameters,
              OperationError<SetDefaultPaymentMethodError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetDefaultPaymentMethodSchema,
              SetDefaultPaymentMethodBody,
              SetDefaultPaymentMethodData,
              SetDefaultPaymentMethodParameters,
              OperationError<SetDefaultPaymentMethodError>,
              TContext
            >
      ):
        | Mutation<
            SetDefaultPaymentMethodData,
            SetDefaultPaymentMethodError,
            MutationVariables<SetDefaultPaymentMethodBody, SetDefaultPaymentMethodParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SetDefaultPaymentMethodBody,
              SetDefaultPaymentMethodData,
              SetDefaultPaymentMethodParameters,
              OperationError<SetDefaultPaymentMethodError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetDefaultPaymentMethodSchema,
              SetDefaultPaymentMethodBody,
              SetDefaultPaymentMethodData,
              SetDefaultPaymentMethodParameters,
              OperationError<SetDefaultPaymentMethodError>,
              TContext
            >
      ): Array<
        Mutation<
          SetDefaultPaymentMethodData,
          SetDefaultPaymentMethodError,
          MutationVariables<SetDefaultPaymentMethodBody, SetDefaultPaymentMethodParameters>,
          TContext
        >
      >;
    };
    schema: SetDefaultPaymentMethodSchema;
    types: {
      parameters: SetDefaultPaymentMethodParameters;
      data: SetDefaultPaymentMethodData;
      error: SetDefaultPaymentMethodError;
      body: SetDefaultPaymentMethodBody;
    };
  };
}
/** @summary Get Customer Payment Methods */
export const getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet = {
  schema: {
    method: 'get',
    url: '/customers/{customer_id}/payment_methods',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema;
  [QraftServiceOperationsToken]: CustomerPaymentMethodsService['getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet'];
};
/** @summary Setup Customer Payment Method */
export const setupCustomerPaymentMethod = {
  schema: {
    method: 'post',
    url: '/customers/{customer_id}/payment_methods/setup',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SetupCustomerPaymentMethodSchema;
  [QraftServiceOperationsToken]: CustomerPaymentMethodsService['setupCustomerPaymentMethod'];
};
/** @summary Set Default Payment Method */
export const setDefaultPaymentMethod = {
  schema: {
    method: 'patch',
    url: '/customers/{customer_id}/payment_methods/{payment_method_id}/default',
    security: ['HTTPBearer'],
  },
} as {
  schema: SetDefaultPaymentMethodSchema;
  [QraftServiceOperationsToken]: CustomerPaymentMethodsService['setDefaultPaymentMethod'];
};
export const customerPaymentMethodsService = {
  getCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGet,
  setupCustomerPaymentMethod,
  setDefaultPaymentMethod,
} as const;
type GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetSchema = {
  method: 'get';
  url: '/customers/{customer_id}/payment_methods';
  security: ['HTTPBearer'];
};
type GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetParameters =
  paths['/customers/{customer_id}/payment_methods']['get']['parameters'];
type GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetData =
  paths['/customers/{customer_id}/payment_methods']['get']['responses']['200']['content']['application/json'];
type GetCustomerPaymentMethodsCustomersCustomerIdPaymentMethodsGetError =
  paths['/customers/{customer_id}/payment_methods']['get']['responses']['422']['content']['application/json'];
type SetupCustomerPaymentMethodSchema = {
  method: 'post';
  url: '/customers/{customer_id}/payment_methods/setup';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SetupCustomerPaymentMethodParameters =
  paths['/customers/{customer_id}/payment_methods/setup']['post']['parameters'];
type SetupCustomerPaymentMethodData =
  paths['/customers/{customer_id}/payment_methods/setup']['post']['responses']['200']['content']['application/json'];
type SetupCustomerPaymentMethodError =
  paths['/customers/{customer_id}/payment_methods/setup']['post']['responses']['422']['content']['application/json'];
type SetupCustomerPaymentMethodBody =
  paths['/customers/{customer_id}/payment_methods/setup']['post']['requestBody']['content']['application/json'];
type SetDefaultPaymentMethodSchema = {
  method: 'patch';
  url: '/customers/{customer_id}/payment_methods/{payment_method_id}/default';
  security: ['HTTPBearer'];
};
type SetDefaultPaymentMethodParameters =
  paths['/customers/{customer_id}/payment_methods/{payment_method_id}/default']['patch']['parameters'];
type SetDefaultPaymentMethodData =
  paths['/customers/{customer_id}/payment_methods/{payment_method_id}/default']['patch']['responses']['200']['content']['application/json'];
type SetDefaultPaymentMethodError =
  paths['/customers/{customer_id}/payment_methods/{payment_method_id}/default']['patch']['responses']['422']['content']['application/json'];
type SetDefaultPaymentMethodBody = undefined;
